import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  FormItem,
  Lookup,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarVeiculosDs, criarTiposVeiculosDs } from "../../DataSources";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import memoria from "../../Memoria";

const localStorageKey = "cadastroVeiculosGridState";

export default class VeiculosBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.veiculosDs = criarVeiculosDs();
    this.tiposVeiculosFiltroDs = [];
    this.tiposVeiculosDs = criarTiposVeiculosDs();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.onSelecionado = props.onSelecionado;

    this.state = {
      opcoesTipoVeiculo: {
        editorType: "dxSelectBox",
        searchEnabled: false,
        dataSource: [],
        placeholder: "Escolher...",
        valueExpr: "id",
        displayExpr: "descricao",
      },
      filtro: {
        codContribuinte: undefined,
        nomeContribuinte: "",
        cpfCnpj: "",
        placa: "",
        marca: "",
        modelo: "",
        renavam: "",
        chassi: "",
        tipoVeiculo: 0,
      },
    };
  }

  componentDidMount() {
    this.tiposVeiculosDs
      .load()
      .then((data) => {
        let tipos = [];
        tipos.push({ id: 0, descricao: " " });
        data.forEach((x) => tipos.push(x));
        this.setState({ opcoesTipoVeiculo: { dataSource: tipos } });
      })
      .catch((erro) => {
        // notify(erro, "Erro ao carregar tipos de véiculos");
      });
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.codContribuinte !== undefined) {
      filtroCorrente.push([
        "contribuinte.sequencial",
        "=",
        filtro.codContribuinte.trim(),
      ]);
    }
    if (filtro.nomeContribuinte !== undefined) {
      filtroCorrente.push([
        "contribuinte.nome",
        "contains",
        filtro.nomeContribuinte.trim(),
      ]);
    }
    if (filtro.cpfCnpj !== undefined) {
      filtroCorrente.push([
        "contribuinte.documento",
        "contains",
        filtro.cpfCnpj.trim(),
      ]);
    }
    if (filtro.placa !== undefined) {
      filtroCorrente.push(["placa", "contains", filtro.placa.trim()]);
    }
    if (filtro.marca !== undefined) {
      filtroCorrente.push(["marca", "contains", filtro.marca.trim()]);
    }
    if (filtro.modelo !== undefined) {
      filtroCorrente.push(["modelo", "contains", filtro.modelo.trim()]);
    }
    if (filtro.renavam !== undefined) {
      filtroCorrente.push(["renavam", "contains", filtro.renavam.trim()]);
    }
    if (filtro.chassi !== undefined) {
      filtroCorrente.push(["chassi", "contains", filtro.renavam.trim()]);
    }
    if (filtro.tipoVeiculo !== undefined && filtro.tipoVeiculo !== 0) {
      filtroCorrente.push(["tipoDeVeiculoId", "=", filtro.tipoVeiculo]);
    }

    this._gridInstance.instance.filter(filtroCorrente);
  }

  limparFiltro() {
    this.setState({ filtro: { tipoVeiculo: 0 } });
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("veiculos/editar/" + e.data.id);
  }

  componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form onSubmit={this.filtrar}>
            <Form id="frmPesquisa" formData={this.state.filtro} colCount={5}>
              <SimpleItem dataField="codContribuinte" colSpan={1}>
                <Label text="Cód. Contribuinte" />
              </SimpleItem>
              <SimpleItem dataField="nomeContribuinte" colSpan={2}>
                <Label text="Nome Contribuinte" />
              </SimpleItem>
              <SimpleItem dataField="cpfCnpj" colSpan={2}>
                <Label text="CPF/CNPJ" />
              </SimpleItem>
              <SimpleItem dataField="placa" colSpan={1}>
                <Label text="Placa" />
              </SimpleItem>
              <SimpleItem dataField="marca" colSpan={2}>
                <Label text="Marca" />
              </SimpleItem>
              <SimpleItem dataField="modelo" colSpan={2}>
                <Label text="Modelo" />
              </SimpleItem>
              <SimpleItem dataField="renavam" colSpan={1}>
                <Label text="Renanvam" />
              </SimpleItem>
              <SimpleItem dataField="chassi" colSpan={2}>
                <Label text="Chassi" />
              </SimpleItem>
              <SimpleItem
                dataField="tipoVeiculo"
                colSpan={2}
                editorType={"dxSelectBox"}
                editorOptions={this.state.opcoesTipoVeiculo}
              >
                <Label text="Tipo Veículo" />
              </SimpleItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.filtrar}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>
          </form>
          <PaginaToolbar
            titulo="Lista de Veículos"
            novoCb={this.novoVeiculo.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.veiculosDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              onEditingStart={this.onAtualizandoRow}
            >
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />
              <Column
                dataField={"sequencial"}
                caption={"#"}
                allowEditing={false}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column dataField={"placa"} caption={"Placa"} />
              <Column dataField={"contribuinte.sequencial"} caption={"IMC"} />
              <Column
                dataField={"contribuinte.nome"}
                caption={"Contribuinte"}
              />
              <Column dataField={"modelo"} caption={"Modelo"} />
              <Column dataField={"marca"} caption={"Marca"} />
              <Column dataField={"anoFabricaEModelo"} caption={"Ano"} />
              <Column dataField={"cor"} caption={"Cor"} />
              <Column dataField={"renavam"} caption={"RENAVAM"} />
              <Column dataField={"tipoDeVeiculoId"} caption={"Tipo de Veículo"}>
                <Lookup
                  dataSource={this.tiposVeiculosDs}
                  valueExpr={"id"}
                  displayExpr={"descricao"}
                />
              </Column>
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                showInfo={true}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoVeiculo() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("veiculos/novo");
  }
}
